import './App.css';
import { Route, Routes, Outlet, Link } from 'react-router-dom';
import Dashboard from "../src/component/studentDashboard/Dashboard";
import Home from '../src/component/Landing/Home';
import About from './component/Landing/Pages/About';
import Pricing from './component/Landing/Pages/Pricing';
import Faq from './component/Landing/Pages/Faq';
import Blog from './component/Landing/Pages/Blog';
import BlogDetails from './component/Landing/Pages/BlogDetails';
import Feature from './component/Landing/Pages/Feature';
import Contact from './component/Landing/Pages/Contact';
import Signin from './component/Landing/Signin/Signin';
import Signup from './component/Landing/Signup/Signup';
import Forgot from './component/Landing/Forgot/Forgot';
import OtpVerify from './component/Landing/Forgot/OtpVerify';
import RegisterValidateOtp from "../src/component/Landing/Signup/RegisterValidateOtp";
import AdminDashboard from './component/AdminDashboard/AdminDashboard';
import SettingsPayment from './component/AdminDashboard/pages/SettingsPayment';
import LeftMenu from './component/AdminDashboard/Sidebar/LeftMenu';
import Navbar from './component/AdminDashboard/Navbar/Navbar';
import CustomerDetails from './component/AdminDashboard/pages/CustomerDetails';
import Footer from './component/AdminDashboard/Footer/Footer';
import Board from './component/AdminDashboard/pages/Board';
import MasterLanguage from './component/AdminDashboard/pages/MasterLanguage';
import MasterSubject from './component/AdminDashboard/pages/MasterSubject';
import AdminSignin from './component/AdminDashboard/Singnin/AdminSignin';
import AdminForgot from './component/AdminDashboard/Forgot/AdminForgot';
import { selectMode, selectSideBar } from "../src/service/slice/ThemeSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchUsers, fetchUserSubscription, setPageLoading } from './service/slice/AuthSlice';
import AddLanguage from './component/AdminDashboard/pages/AddLanguage';
import AddSubject from './component/AdminDashboard/pages/AddSubject';
import UserList from './component/AdminDashboard/pages/UserList';
import AdminOtpVerify from './component/AdminDashboard/Forgot/AdminOtpVerify';
import StudyProfile from './component/AdminDashboard/pages/StudyProfile';
import Package from './component/AdminDashboard/pages/Package';
import AddPackage from './component/AdminDashboard/pages/AddPackage';
import Loading from './component/Loading';
import SubscriptionHistory from './component/AdminDashboard/pages/SubscriptionHistory';
import SearchHistory from './component/AdminDashboard/pages/SearchHistory';
import LeftSidebar from './component/studentDashboard/LeftSidebar/LeftSidebar';
import Header from './component/studentDashboard/Header/Header';
import Activity from '../src/component/studentDashboard/Pages/Activity';
import EditProfile from '../src/component/studentDashboard/Pages/EditProfile';
import PackageHistory from '../src/component/studentDashboard/Pages/PackageHistory';
import AdminContact from "../src/component/AdminDashboard/pages/Contact";
import GoogleVerified from './component/Landing/Signup/GoogleVerified';
import PrivacyPolice from "../src/component/Landing/Pages/PrivacyPolicy";
import TermsCondition from "../src/component/Landing/Pages/TermsCondition";
import QuestionAnsView from './component/studentDashboard/QuestionAnsView';


function Layout({ loading }) {
  const theme = useSelector(selectMode);
  const sideBar = useSelector(selectSideBar)

  const themeColor = {
    color: theme === 'light' ? '#000' : '#fff',
    background: theme === 'light' ? '#fff' : '#282a42ec',
    boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)',
  };

  return (
    <>
      {loading ?
        <Loading />
        :
        <div className={sideBar ? "layout-wrapper layout-content-navbar" : "layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed layout-menu-hover"} style={themeColor}>
          <div className="layout-container">
            <LeftMenu />
            <div className="layout-page">
              <Navbar />
              <div className="content-wrapper" style={{ marginTop: '70px' }}>
                <Outlet />
                <Footer />
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}

function UserLayout({ loading }) {
  const pageLoading = useSelector((state) => state.userSlice?.pageLoading);
  const theme = useSelector(selectMode);
  const themeColor = {
    color: theme === 'light' ? '#000' : '#fff',
    background: theme === 'light' ? '#fff' : '#090E18',
    boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)',
  };

  return (
    <>
      {loading ?
        <Loading />
        :
        <>
          {/* Header */}
          <Header />
          <div className="dash-board-main-wrapper" style={themeColor}>
            <LeftSidebar />

            <div className="main-center-content-m-left center-content search-sticky">
              <div className="rts-faq-area rts-section-gapBottom bg_faq">
                <div className="container">
                  <Outlet />
                </div>
              </div>

            </div>

            <div className="copyright-area-bottom">
              <p><Link to="/">Cuzysolve &copy;</Link> 2025. All Rights Reserved.</p>
            </div>

          </div>
        </>
      }
    </>
  );
}



function App() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state?.userSlice?.value)
  useEffect(() => {
    if (!userDetails) {
      if (localStorage.getItem('authAdminToken')) {
        dispatch(fetchUsers({ token: localStorage.getItem('authAdminToken'), type: "admin" }))
        dispatch(setPageLoading({ pageLoading: false }));
      } else if (localStorage.getItem('authToken') && !window.location.pathname.includes('admin')) {
        dispatch(fetchUsers({ token: localStorage.getItem('authToken'), type: "user" }))
        dispatch(fetchUserSubscription(localStorage.getItem('authToken')))
        dispatch(setPageLoading({ pageLoading: false }));
      } else if (window.location.pathname.includes('/admin/') || window.location.pathname.includes('/user/')) {
        setTimeout(() => {
          setLoading(false)
        }, 1500);
        window.location.href = "/";
      } else if (window.location.pathname == '/admin') {
        setTimeout(() => {
          setLoading(false)
        }, 1500);
        window.location.href = "/adminSignin";
      }
    } else {
      if (userDetails.admin && (!window.location.pathname.includes('/admin/') || window.location.pathname != '/admin')) {
        window.location.href = "/";
      }
    }
  }, [])

  const pageLoading = useSelector((state) => state.userSlice?.pageLoading);
  useEffect(() => {
    if (!pageLoading) {
      setTimeout(() => {
        setLoading(false)
      }, 1500);
    }
  }, [pageLoading])

  return (

    <Routes>

      {/* Admin Section */}
      <Route path='/adminSignin' element={<AdminSignin />} />
      <Route path='/adminForgot' element={<AdminForgot />} />
      <Route exact path='/adminotpverify' element={<AdminOtpVerify />} />

      <Route element={<Layout loading={loading} />} >
        <Route exact path='/admin' element={<AdminDashboard />} />
        <Route exact path='/admin/settingspayment' element={<SettingsPayment />} />
        <Route exact path='/admin/customerdetails/:id' element={<CustomerDetails />} />
        <Route exact path='/admin/board' element={<Board />} />
        <Route exact path='/admin/masterlanguage' element={<MasterLanguage />} />
        <Route exact path='/admin/mastersubject' element={<MasterSubject />} />
        <Route exact path='/admin/addlanguage' element={<AddLanguage />} />
        <Route exact path='/admin/addsubject' element={<AddSubject />} />
        <Route exact path='/admin/userlist' element={<UserList />} />
        <Route exact path='/admin/studyprofile' element={<StudyProfile />} />
        <Route exact path='/admin/package' element={<Package />} />
        <Route exact path='/admin/addpackage' element={<AddPackage />} />
        <Route exact path='/admin/subscriptionhistory' element={<SubscriptionHistory />} />
        <Route exact path='/admin/searchHistory/:id' element={<SearchHistory />} />
        <Route exact path='/admin/contact' element={<AdminContact />} />
      </Route>


      {/* User Section */}
      <Route element={<UserLayout loading={loading} />} >
        <Route path='/user/dashboard' element={<Dashboard />} />
        <Route path='/user/questionview' element={<QuestionAnsView />} />
        <Route path='/user/editprofile' element={<EditProfile />} />
        <Route path='/user/activity' element={<Activity />} />
        <Route path='/user/packagehistory' element={<PackageHistory />} />
      </Route>

      <Route exact path='/' element={<Home />} />
      <Route path='/pricing' element={<Pricing />} />
      <Route path='/about' element={<About />} />
      <Route path='/faq' element={<Faq />} />
      <Route path='/blog' element={<Blog />} />
      <Route path='/blog-details' element={<BlogDetails />} />
      <Route path='/feature' element={<Feature />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/signin' element={<Signin />} />
      <Route path='/signup' element={<Signup />} />
      <Route path='/forgot' element={<Forgot />} />
      <Route path='/otpVerify' element={<OtpVerify />} />
      <Route path='/registerValidateOtp' element={<RegisterValidateOtp />} />
      <Route path='/googleVerified' element={<GoogleVerified />} />
      <Route path='/privacypolicy' element={<PrivacyPolice />} />
      <Route path='/termscondition' element={<TermsCondition />} />
    </Routes>
  );
}

export default App;
